import Factory from '../utils/factory'

export default Factory({
  id: null,
  scopes: [],
})
